// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3CFkI","label":"Section_label__3Gvn3","contentWrap":"Section_contentWrap__3DC7e","footer":"Section_footer__2yRmK","footerInner":"Section_footerInner__ksnkZ"};